function normalizeSrc(src: string): string {
    return src.startsWith('/') ? src.slice(1) : src
}

// Docs: https://developers.cloudflare.com/images/transform-images
export function cloudflareImageUrl({ src, width, quality = 85 }: { src: string; width: number; quality?: number }): string {
    const params = [`width=${width}`, `quality=${quality}`, 'format=auto']
    return `${getResizerUrl()}/image/${params.join(',')}/${normalizeSrc(src)}`
}

export function getResizerUrl(): string {
    const imageDomain = process.env.NODE_ENV === 'development' ? 'not-theinventory.com' : 'theinventory.com'
    return `https://${imageDomain}/cdn-cgi`
}

export function getStaticAssetUrl(image: 'default' | 'placeholder' | 'caret'): string {
    return `https://assets.qz.com/media/${image}.${image === 'caret' ? 'png' : 'jpg'}`
}

export function getLogoAssetUrl(type: 'light' | 'default' | 'email' | 'membership'): string {
    const base = 'https://assets.qz.com/logos'
    switch (type) {
        case 'email':
            return `${base}/email-logo.png`
        case 'light':
            return `${base}/light.png`
        case 'membership':
            return `${base}/logo-quartz-membership.png`
    }

    return `${base}/Logo.svg`
}
